import { APIManager } from "shared/manager";
import { RestEnds } from "../shared/Constants";
import AxiosManager from "shared/manager/AxiosManager";

const createUser = async (data) => {
  return APIManager.sendPost(
    RestEnds.CREATE_USER,
    AxiosManager,
    data,
    false,
    {},
    {}
  );
};

const updateUser = async (data) => {
  return APIManager.sendPatch(
    `${RestEnds.USER}`,
    AxiosManager,
    data,
    true,
    {},
    {}
  );
};

const getLoanStatus = async () => {
  return APIManager.sendGet(
    `${RestEnds.USER_LOAN_STATUS}?offset=1&limit=20`,
    AxiosManager,
    true,
    {},
    {}
  );
};

const createUserLoan = async (data) => {
  return APIManager.sendPost(
    RestEnds.CREATE_USER_LOAN,
    AxiosManager,
    data,
    true,
    {},
    {}
  );
};

const generateUserToken = async (data) => {
  return APIManager.sendPost(
    RestEnds.GENERATE_USER_TOKEN,
    AxiosManager,
    data,
    true,
    {},
    {}
  );
};

const loginUser = async (data) => {
  return APIManager.sendPost(RestEnds.LOGIN, AxiosManager, data, false, {}, {});
};

const requestOTP = async (data) => {
  return APIManager.sendPost(
    RestEnds.REQUEST_OTP,
    AxiosManager,
    data,
    false,
    {},
    {}
  );
};

const verifyEmail = async (data) => {
  return APIManager.sendPost(
    RestEnds.VERIFY_EMAIL,
    AxiosManager,
    data,
    false,
    {},
    {}
  );
};

export const AuthenticationService = {
  createUser,
  loginUser,
  requestOTP,
  verifyEmail,
  updateUser,
  getLoanStatus,
  createUserLoan,
  generateUserToken,
};
